import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";

function Dialog({
  title, open, onClose, children, footer, wide,
}: {
  title: string;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  wide?: boolean;
}) {
  if (!open) return null;
  return (
    <DialogPrimitive.Root open onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Content
          className="dialog-backdrop"
          aria-describedby={undefined}
          onPointerDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
          <div className="dialog-frame" onPointerDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className={cn("dialog", wide && "wide")} role="document">
              <div className="dialog-head">
                <DialogPrimitive.Title>{title}</DialogPrimitive.Title>
                <DialogPrimitive.Close type="button" className="dialog-close" aria-label="Fechar diálogo">
                  <X aria-hidden="true" />
                </DialogPrimitive.Close>
              </div>
              {children}
              {footer && <footer>{footer}</footer>}
            </div>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

export { Dialog };
